import React from 'react'
import { Modal } from 'react-bootstrap'
import ModalHeader from 'react-bootstrap/esm/ModalHeader'
import { BsXCircle } from 'react-icons/bs'
import {useContext } from 'react'
import TripContext from '../contexts/TripContext'

export default function RulesModal (props) {

  let tripContext = useContext(TripContext)


  // state = {}

  // constructor() {
  //   super()
  //   this.closeModal = this.closeModal.bind(this)
  // }

  // closeModal() {
  //   this.props.onChange()
  // }

  
    return (
      <Modal show={props.show} onHide={props.onChange}>
       
        <>
        <div className="d-flex justify-content-center w-100 align-items-center text-right p-2">

        <iframe src={tripContext.trip.rulesUrl} height="500" className='w-100' title="myFrame">
        </iframe>












































          {/* <span>
            نرم‌افزار {process.env.REACT_APP_NAME} که توسط شرکت ابتکار فناوران سهند پویا برای تسهیل
            جابجایی مسافر طراحی گردیده، تحت شرایط زیر خدمات مربوطه را ارائه
            می‌‌نماید؛ لذا این شرایط به‌عنوان یک قرارداد الزام‌آور بر روابط بین
            کاربران و شرکت حاکم خواهد بود. بر این اساس، ضروری است پیش از استفاده
            از خدمات {process.env.REACT_APP_NAME}، این شروط را به‌دقت مطالعه فرمایید. استفاده از
            خدمات {process.env.REACT_APP_NAME} به‌منزله‌ی قبول تمامی شرایط ذیل است و هرگونه ادعا یا
            اعتراض آتی در این خصوص را بلااعتبار می‌‌نماید. تعاریف واژگان و
            اصطلاحاتی که در شرایط استفاده حاضر مورد استفاده قرار گرفته‌اند،
            دارای معانی به شرح ذیل می‌باشند: الف) شرکت: شرکت ابتکار فناوران سهند
            پویا به‌عنوان مالک نام تجاری {process.env.REACT_APP_NAME} که به‌عنوان واسط میان مسافر و
            سفیر از طریق اپلیکیشن متعلق به خود و نیز وب‌اپ و خدمات تلفنی به
            ارائه خدمات هوشمند جابجایی مسافر می‌پردازد. ب) {process.env.REACT_APP_NAME}: نام و
            علامت تجاری متعلق به شرکت می‌باشد که از طریق سامانه، اپلیکیشن ،
            وب‌اپ و خدمات تلفنی به ارائه خدمات هوشمند جابجایی مسافر می‌پردازد.
            پ) اپلیکیشن: عبارت است از اپلیکیشن {process.env.REACT_APP_NAME} در دو نسخه سفیران و
            مسافران، جهت استفاده در گوشی‌های هوشمند با سیستم عامل اندروید
            که ارائه خدمات هوشمند جابجایی {process.env.REACT_APP_NAME} در بستر آن امکان‌پذیر است.
            کلیه حقوق مادی و معنوی این اپلیکیشن متعلق به شرکت می‌باشد. ت) وب‌اپ:
            بهره‌گیری از خدمات هوشمند جابجایی مسافر از طریق وب‌اپ {process.env.REACT_APP_NAME} به
            آدرس http://arak.efspco.ir می‌باشد. ث) سامانه {process.env.REACT_APP_NAME}: عبارت است
            از مجموع امکانات نرم‌افزاری {process.env.REACT_APP_NAME} که از طریق نیروی انسانی شرکت
            نسبت به ارائه خدمات از مرحله ثبت نام کاربران تا انجام پشتیبانی
            می‌پردازد. ج) مسافر/کاربر/ کاربر مسافر: متقاضی استفاده از سرویس
            هوشمند جابجایی مسافر {process.env.REACT_APP_NAME} که با ثبت نام در سامانه {process.env.REACT_APP_NAME}
            نسبت به ارسال درخواست سفر با تعیین مبدأ و مقصد اقدام می‌نماید. چ)
            سفیر: راننده وسیله نقلیه که با ثبت نام در سامانه {process.env.REACT_APP_NAME}، نسبت به
            جابجایی مسافر از مبدأ به مقصد اقدام می‌نماید. ح) وسیله نقلیه: عبارت
            است از خودرو ثبت نام شده در سامانه {process.env.REACT_APP_NAME} که مشخصات آن در کارت
            ماشین سفیر ذکر شده است و جهت جابجایی مسافر مورد استفاده قرار
            می‌گیرد. خ) حساب کاربری: عبارت است از حسابی که کاربران جهت استفاده
            از خدمات {process.env.REACT_APP_NAME} با وارد نمودن اطلاعات مورد نظر در سامانه، ایجاد
            می‌نمایند و از طریق آن از خدمات بهره‌مند می‌گردند. ماده ۱- ایجاد
            حساب کاربری و شرایط آن ۱‏-۱- برای عضویت در {process.env.REACT_APP_NAME} و استفاده از
            تمامی خدمات آن، لازم است کاربر مسافر اقدام به ایجاد یک حساب کاربری
            در {process.env.REACT_APP_NAME} نماید. برای ایجاد حساب کاربری شرایط زیر الزامی است:
            داشتن ۱۸ سال تمام شمسی تکمیل فرم مشخصات از قبیل نام، نام خانوادگی و
            شماره‌ی تلفن همراه در خصوص اشخاص حقوقی، نماینده‌ی شرکت اقدام به وارد
            نمودن مشخصات شرکت در پنل سازمانی می‌‌نماید و اطلاعات ثبتی شرکت از
            قبیل نام کامل شرکت، شماره‌ی ثبت و شناسه‌ی ملی شرکت در اداره‌ی ثبت
            شرکت‌‌ها، شماره تلفن ثابت، لوگو و تعداد پرسنل شرکت و نیز مشخصات خود
            را اعلام می‌نماید. ۱‏-۲- هر شخص (اعم از حقیقی و حقوقی) تنها مجاز به
            افتتاح یک حساب کاربری در {process.env.REACT_APP_NAME} است. ۱‏-۳- کاربر مسافر مسئولیت
            صحت اطلاعات مندرج در حساب کاربری را می‌‌پذیرد و متعهد می‌‌شود که در
            صورت تغییر در هر بخش از این اطلاعات، حساب کاربری خود را در {process.env.REACT_APP_NAME}
            به‌روز نماید. وارد کردن اطلاعات نادرست و غیردقیق ممکن است منجر به
            محرومیت کاربر مسافر از خدمات {process.env.REACT_APP_NAME} شود و وی نمی‌‌تواند به این
            موضوع معترض گردد. ۱‏-۴- هر کاربر مسافر با ثبت‌نام در {process.env.REACT_APP_NAME} و
            ایجاد حساب کاربری به نام خود صحت انتساب تمام پیام‌‌های صادره ازحساب
            کاربری خویش را پذیرفته و در نتیجه حق هرگونه اعتراض یا ادعای آتی
            (مبنی بر انکار، تردید یا جعل داده‌ی پیام‌های ارسالی) را از خویش سلب
            و اسقاط می‌‌نماید. ۱‏-۵- در صورت عدم همکاری کاربر مسافر و ارائه
            نکردن اطلاعات مربوط—در شرایط خاص که ممکن است احراز هویت کاربر مسافر
            از جانب شرکت ضروری تشخیص داده شود—شرکت حق انسداد حساب کاربری مسافر
            را خواهد داشت. ماده ۲- هزینه‌‌ استفاده از خدمات و نحوه‌ی پرداخت آن
            ۲‏-۱- با توجه به این‌که اتصال به اینترنت برای استفاده از نرم‌افزار
            {process.env.REACT_APP_NAME} ضروری است، کاربر می‌‌بایست اینترنت مورد نیاز را به‌انضمام
            سایر لوازم استفاده از نرم‌افزار {process.env.REACT_APP_NAME} تدارک ببیند و مخارج آن‌‌ها
            را شخصاً تأمین نماید. بدین‌‌وصف، هزینه‌ای که به‌عنوان هزینه‌ی سفر
            محاسبه و از کاربر دریافت می‌‌شود، مشتمل بر مخارج اینترنت مصرفی و
            موارد مشابه نبوده و تنها بهای خدمات ارائه‌شده از سوی نرم‌افزار 1828
            اراک است. ۲‏-۲- هزینه‌ی سفر از طریق نرم‌افزار {process.env.REACT_APP_NAME} محاسبه و به
            کاربر مسافر اعلام می‌‌گردد. هزینه‌ی خدمات ارائه‌شده با توجه به زمان
            درخواست سفر (ساعات مختلف یا روزهای هفته)، مبدأ و مقصد سفر و دیگر
            عوامل مؤثر متغیر خواهد بود و کاربر پس از مشاهده‌ی قیمت و ارسال
            درخواست سفر حق هرگونه اعتراض در این خصوص را از خود سلب و اسقاط
            می‌‌نماید. تبصره: از مجموع مبلغ پرداختی فوق، عوارض شهرداری به‌صورت
            خودکار کسر شده و مبلغ باقی‌مانده پس از کسر حق استفاده و بهره برداری
            {process.env.REACT_APP_NAME} در وجه سفیر کارسازی می‌گردد. ۲‏-۳- هزینه‌ی سفر که در هنگام
            درخواست برای کاربر مسافر نمایش داده می‌‌شود بر اساس ظرفیت مندرج در
            کارت ماشین سفیر و بدون بار تعیین و محاسبه شده است. هر تغییری در
            شرایط سفر از سوی کاربر مسافر، از قبیل درخواست تغییر مبدأ، مقصد، یا
            درخواست توقف در طی مسیر و مانند آن، {process.env.REACT_APP_NAME} را مجاز خواهد کرد که
            بر طبق موازین قیمت‌گذاری خود قیمت تعیین‌شده را تغییر دهد. در سایر
            موارد، قیمت تعیین‌شده غیرقابل‌تغییر خواهد بود. ۲‏-۴- کاربر مسافر،
            هزینه سفر (کرایه) را به یکی از دو روش زیر پرداخت می‌نماید: (۱)
            پرداخت اینترنتی از طریق نرم‌افزار {process.env.REACT_APP_NAME} یا (۲) پرداخت نقدی به
            سفیر. در صورتی که کاربر مسافر، مایل به پرداخت اینترنتی هزینه سفر
            باشد، می‌بایست با پرداخت وجه مورد نظر خود از طریق درگاه‌های بانکی
            پرداخت اینترنتی، اعتبار حساب کاربری خود را شارژ نماید. ۲‏-۵- در
            مواردی به تشخیص و صلاحدید شرکت، بسته‌‌های تشویقی (به‌صورت عمومی و
            برای همه‌ی کاربران مسافر یا به‌صورت اختصاصی و برای کاربران خاص)،
            به‌عنوان هدیه و بدون دریافت هزینه، برای کاربران مسافر در نظر گرفته
            می‌‌شود که در قالب آن یا مبلغ مشخصی به‌عنوان هدیه به اعتبار مسافر
            افزوده می‌‌شود یا تخفیف مشخصی به مسافر اختصاص می‌یابد. در صورتی که
            بسته‌‌ها دارای تاریخ اعتبار مشخصی باشند، پس از آن تاریخ بلااعتبار
            خواهند بود. مضاف بر آن و با توجه به هدیه بودن بسته های مذکور، به
            تشخیص شرکت این بسته‌ها در هر زمانی قابل تغییر، تعلیق یا ابطال خواهند
            بود و شرکت این حق را برای خود محفوظ می‌‌دارد که بدون تدارک هیچ دلیلی
            هر یک از این بسته‌ها را غیرفعال نماید. ماده ۳- حقوق و مسئولیت‌های
            کاربر مسافر ۳‏-۱- کاربر مجاز نیست حساب کاربری خود را برای استفاده در
            اختیار دیگر اشخاص–اعم از حقیقی و حقوقی و به‌ویژه افراد زیر ۱۸
            سال–قرار دهد یا آن را به هر نحو به دیگری منتقل نماید. در صورت تخلف،
            مسئولیت تمام اقدامات انجام شده از سوی این اشخاص، به‌عهده‌ی صاحب حساب
            کاربری خواهد بود. ۳‏-۲- مسئولیت تمامی فعالیت‌هایی که از طریق حساب
            کاربری انجام می‌‌شود، مطلقاً به‌عهده‌ی شخص کاربر است، در نتیجه ضروری
            است که کاربر در حفظ اطلاعات حساب کاربری خود، از جمله نام کاربری و کد
            تایید، حداکثر اقدامات لازم را مبذول دارد و از این طریق مانع
            استفاده‌ی دیگران از آن گردد. همچنین ضروری است که کاربر در صورت ظن به
            دسترسی ثالث به حساب کاربری در اسرع وقت شرکت را مطلع کند. ۳‏-۳- کاربر
            متعهد است که در استفاده از خدمات {process.env.REACT_APP_NAME} تمامی قوانین جمهوری
            اسلامی ایران را رعایت کند، نرم‌افزار را برای اهداف قانونی به‌کار
            گیرد و در همه حال، با در نظر گرفتن حیثیت تجاری نرم‌افزار {process.env.REACT_APP_NAME} و
            شرکت، مرتکب رفتاری نشود که اعتبار نرم‌افزار {process.env.REACT_APP_NAME} را خدشه‌‌دار
            نماید. مسئولیت هر نوع اقدام کاربر که منجر به بروز آسیب بدنی، جانی یا
            مالی به اشخاص گردد، به‌عهده‌ی کاربر است و شرکت در این خصوص مسئولیتی
            نخواهد داشت. ۳‏-۴- کاربر اقرار می‌‌نماید که با افتتاح حساب کاربری در
            {process.env.REACT_APP_NAME} تنها مجوز استفاده‌ی غیرانحصاری، غیرقابل‌انتقال و محدود از
            خدمات آن را دریافت می‌‌کند و به این ترتیب مدعی مالکیت یا حقی نسبت به
            {process.env.REACT_APP_NAME} (اعم از کپی‌رایت، علامت تجاری و سایر حقوق معنوی آن) نیست،
            در غیر موارد مصرح در این قرارداد اجازه‌ی استفاده از نام و علامت
            تجاری و خدمات نرم‌افزار {process.env.REACT_APP_NAME} را ندارد و در همه حال متعهد به
            رعایت حقوق معنوی شرکت نسبت به نرم‌افزارها و ملحقات آن خواهد بود.
            ۳‏-۵- کاربر می‌‌پذیرد که قرارداد حاضر یک قرارداد قابل رجوع و جایز از
            سوی شرکت است و شرکت می‌‌تواند هر زمان تنها به صلاحدید خود و بدون
            نیاز به تدارک هیچ‌گونه دلیلی، یک حساب کاربری را مسدود کند و مانع
            استفاده‌ی کاربر مسافر از خدمات {process.env.REACT_APP_NAME} گردد. ۳‏-۶- کاربر متعهد است
            از اطلاعاتی که در نتیجه‌ی استفاده از خدمات {process.env.REACT_APP_NAME} کسب نموده است
            (مانند اطلاعات تماس سفیر و ...) خارج از سامانه {process.env.REACT_APP_NAME} استفاده
            نکرده، از ارسال درخواست مستقیم سفر برای سفیران خارج از سامانه 1828
            اراک اجتناب نماید. ۳‏-۷- کاربر متعهد است تمامی تغییرات، الحاقات و
            اصلاحاتی را که توسط شرکت از طریق پیامک، ایمیل یا نرم‌افزار {process.env.REACT_APP_NAME}
            در خصوص استفاده از خدمات {process.env.REACT_APP_NAME} و شرایط آن برای کاربر ارسال
            می‌‌گردد مطالعه نماید و در صورت موافقت آن را تأیید نماید. تأیید
            مزبور ممکن است در قالب یک علامت،کلمه، عدد، عبارت، نام تایپ‌شده و
            امثال آن به‌عمل آید که به سند ارسالی الحاق می‌‌شود و همانند امضای
            دست‌نویس دارای آثار حقوقی است و امضاکننده را به مفاد سندی که به‌طریق
            مزبور امضا نموده است متعهد و ملتزم می‌‌نماید. ۳‏-۸- کاربر می‌‌پذیرد
            که بسته‌های تشویقی اختصاصی (و نه بسته‌های تشویقی عمومی)، که در بند
            ۲-۵ شرایط استفاده پیش‌بینی شده است، برای استفاده‌ی شخصی وی در نظر
            گرفته شده و به همین دلیل می‌‌بایست از انتقال و فروش آن‌ها اجتناب
            نماید. ۳‏-۹- کاربر می‌‌پذیرد که اعتبار ناشی از بسته‌های
            تشویقی—پیش‌بینی‌شده در بند ۲-۵ شرایط استفاده—غیرقابل‌تبدیل به وجه
            نقد است و از این رو کاربر نمی‌‌تواند وجه معادل بسته‌های تشویقی را از
            شرکت مطالبه نماید. ۳‏-۱۰- در صورتی که یک فرد با مشخصات هویتی معین
            به‌عنوان مسافر برای یک سفر درخواست ارسال کند و همان فرد این درخواست
            را به‌عنوان سفیر قبول کند، عمل مزبور تقلب قلمداد می‌‌شود و شرکت را
            مجاز خواهد نمود که چهار برابر هزینه‌ی سفر انجام‌شده به‌طریق فوق را
            از متقلب وصول نماید. در شرایطی که این مبلغ تکافوی جبران خسارت وارده
            را نکند، شرکت مجاز خواهد بود بنا به تشخیص خود خسارت وارده را از
            متقلب مطالبه نماید. وصول این مبالغ نافی حق شرکت برای انسداد حساب
            کاربری مذکور نخواهد بود. در صورتی که که وابستگان یک فرد با همکاری وی
            اقدام به اعمال مشابه کنند یا کاربران به هر شکل نسبت به شرکت اِعمال
            حیله و تقلب نمایند و بدین‌وسیله موجبات ضرر شرکت را فراهم آورند،
            مشمول حکم اخیر خواهند بود. ۳‏-۱۱- کاربر مسافر تعهد می‌‌نماید از حمل
            کالاهای ممنوعه نظیر مشروبات الکلی، مواد مخدر، اسلحه، وسایل قمار و
            ... در طول سفر اجتناب نماید. درخواست ارسال هر یک از این کالاها
            به‌تنهایی و بدون همراهی مسافر نیز مشمول حکم این ماده خواهد بود.
            ۳‏-۱۲- کاربر مسافر در طول سفر ملزم به رعایت قوانین جمهوری اسلامی
            ایران از هر نظر است و در نتیجه رعایت مقررات مربوط به حجاب برای
            بانوان یا ممنوعیت نگهداری برخی حیوانات خانگی در خودرو برای مسافر
            الزامی است. ۳‏-۱۳- حداکثر تعداد مجاز مسافر در هر خودرو مطابق با
            ظرفیت مندرج در کارت ماشین سفیر می‌باشد و مسافر نمی‌تواند درخواست
            انجام سفر با بیش از این تعداد را نماید. ۳‏-۱۴- مسافر موظف است در
            زمان مقرر در مبدأ سفر (نشانی‌ای که در درخواست سفر ثبت شده ‌است) حضور
            یابد. حداکثر مدت زمان انتظار سفیر جهت حضور مسافر پنج دقیقه می‌باشد
            در غیر این‌صورت، مسافر می‌بایست نسبت به ثبت زمان توقف در نرم افزار
            اقدام نماید. عدم افزودن زمان توقف، سفیر را مجاز به لغو درخواست سفر
            خواهد نمود. ۳‏-۱۵- کاربر مسافر موظف است هزینه‌ی سفر را که وفق مفاد
            ماده‌ی ۲ شرایط استفاده توسط نرم‌افزار {process.env.REACT_APP_NAME} تعیین می‌‌گردد، به
            یکی از طرق پیش‌بینی‌شده در آن ماده پرداخت نماید. پس از ارسال درخواست
            سفر (در شرایطی که سفر وفق درخواست اولیه انجام پذیرد و در شرایط آن
            تغییری داده نشود) یا پس از پایان سفر (در فرضی که شرایط سفر وفق مفاد
            بند 3-2 تغییر یابد) کاربر مسافر نمی‌‌تواند به میزان هزینه‌ی سفر
            اعتراض کند یا پس از پرداخت، تقاضای استرداد مبلغ پرداختی را بنماید.
            در صورتی که کاربر مسافر به هر علت—از جمله به‌خاطر اشکالات فنی،
            ارتباطی، قطع شبکه‌ی تلفن همراه، بروز نقص در نرم‌افزار و ...—نتواند
            هزینه‌ی سفر را پرداخت کند، شرکت مجاز خواهد بود که این هزینه‌ را از
            اعتبار موجود در حساب کاربری ایشان در {process.env.REACT_APP_NAME} کسر کند. در صورت
            فقدان موجودی، شرکت مجاز است اعتبار حساب کاربری را به میزان هزینه سفر
            مذکور منفی نماید و از پرداخت‌های بعدی مسافر کسر نماید و کاربر
            نمی‌‌تواند نسبت به این اقدام اعتراضی داشته باشد. ۳‏-۱۶- کاربر مسافر
            می‌‌پذیرد که اعتبار موجود در حساب کاربری متعلقه منحصراً جهت
            بهره‌گیری از خدمات {process.env.REACT_APP_NAME} قابل استفاده است و حق مطالبه‌ی دریافت
            نقدی این وجوه را نخواهد داشت. ماده ۴- حقوق و مسئولیت‌های شرکت ۴‏-۱-
            {process.env.REACT_APP_NAME} خدمات حمل‌ونقل ارائه نمی‌‌کند، بلکه تنها با ایجاد یک پل
            ارتباطی بین مسافران و سفیران حمل‌ونقل مسافران را تسهیل می‌‌نماید.
            بدین‌‌توضیح که در {process.env.REACT_APP_NAME}، سفیر میان پذیرش درخواست سفر یا رد آن
            مخیر است و مسافر نیز پس از ارسال درخواست سفر و مشخص شدن سفیر
            می‌‌تواند از درخواست خود انصراف دهد. بدین‌وصف، هر سفری که در قالب
            این برنامه‌ی نرم‌افزاری صورت می‌‌گیرد یک قرارداد مستقل فی‌مابین سفیر
            و مسافر است و {process.env.REACT_APP_NAME} تنها زمینه‌ی انعقاد این قرارداد را میان
            مسافران و رانندگان در هر سفر مهیا می‌‌کند. از این رو، شرکت مسئولیت
            حقوقی یا کیفری در قبال اتفاقات حین سفر ندارد. ۴‏-۲- در صورت تحویل
            کالا یا بسته توسط مسافر به سفیر، شرکت هیچ گونه مسئولیتی در قبال
            تحویل، مفقود شدن یا سلامت آن در هنگام تحویل به عهده نخواهد داشت. حکم
            اخیر در خصوص اشیا به جا مانده از مسافر در خودرو سفیر نیز جاری خواهد
            بود. ۴‏-۳- شرکت متعهد به تلاش برای ارائه‌ی خدمات باکیفیت است و در
            این راه تلاش می‌‌کند با به‌روزرسانی نرم‌افزارها متناسب با نیاز
            کاربران سطح خدمات ارائه‌شده را ارتقا بخشد. ۴‏-۴- شرکت هیچ‌گونه
            مسئولیتی در خصوص عملکرد اشخاص ثالث—که ممکن است موجب حدوث نقص یا
            اشکال و ایرادی در حساب کاربری کاربر گردد—نخواهد داشت. ۴‏-۵- شرکت
            نمی‌‌تواند اجرا شدن برنامه‌ی {process.env.REACT_APP_NAME} را در تمامی سخت‌افزارها،
            دستگاه‌های تلفن همراه یا شبکه‌های ارتباطی تضمین نماید. ۴‏-۶- با توجه
            به این که در خدمات تلفنی، درخواست سفر در بستر نرم‌افزار {process.env.REACT_APP_NAME}
            ارسال می‌شود و از این حیث هیچ تفاوتی با سایر سفرهای انجام شده در
            سامانه {process.env.REACT_APP_NAME} ندارد، حقوق و مسئولیت‌های شرکت در این خدمات مشابه
            سایر سرویس‌ها می‌باشد. ماده ۵- حفاظت از داده‌ها و اطلاعات کاربر
            مسافر الف) داده‌ها و اطلاعات مورد نیاز از کاربر مسافر ۵‏-۱- کاربران
            مسافر اطلاعات زیر را در جهت استفاده از خدمات {process.env.REACT_APP_NAME} در اختیار
            شرکت قرار می‌دهند: اطلاعاتی که کاربر مسافر به‌صورت مستقیم در فرم
            مشخصات ثبت‌نام (نام، نام خانوادگی، شماره‌ی تلفن همراه، پست
            الکترونیک، معرف و ...) و سایر اطلاعات مذکور در ماده ۱ در اختیار شرکت
            قرار می‌‌دهد. اطلاعاتی که به‌طور غیرمستقیم و در نتیجه‌ی استفاده‌ی
            کاربر مسافر از خدمات {process.env.REACT_APP_NAME} در این برنامه ذخیره می‌‌شود؛ از جمله
            موقعیت مکانی مبدأ سفرهای کاربر، طول هر سفر، نشانی مقصد، هزینه‌ی سفر،
            تراکنش‌های مالی صورت‌گرفته در حساب کاربری جهت استفاده از خدمات 1828
            اراک و اطلاعات مربوط به سخت‌افزاری که کاربر با استفاده از آن از
            خدمات {process.env.REACT_APP_NAME} استفاده می‌‌کند (نظیر سیستم‌عامل آن) و نهایتاً
            شیوه‌ی اتصال کاربر به اینترنت و ... تبصره در مواردی شرکت به کاربران
            مسافر اجازه می‌‌دهد عکس، فایل صوتی یا تصویری، اطلاعات، دست‌نوشته یا
            نظرات خود را در نرم‌افزار {process.env.REACT_APP_NAME} منتشر کنند. محتوای تولیدشده—و نه
            کپی‌شده—توسط کاربران مسافر به‌شیوه‌ی مذکور در مالکیت کاربران قرار
            دارد، اما کاربران با بارگذاری این موارد بر نرم‌افزار {process.env.REACT_APP_NAME}
            اجازه‌ی استفاده، تغییر و انتشار آن را به هر نحو و در هر زمان به‌صورت
            رایگان، غیرقابل‌رجوع و قابل انتقال به شرکت واگذار می‌‌کنند. ب) موارد
            استفاده از داده‌ها و اطلاعات کاربر مسافر و نحوه حفاظت از آن ۵‏-۲-
            شرکت در راستای حفظ حریم خصوصی کاربران مسافر اعم از حقیقی و حقوقی با
            رعایت اصل محرمانگی و التزام به قوانین و مقررات مربوطه، داده‌ها و
            اطلاعات دریافتی از کاربر مسافر را در موارد زیر مورد استفاده قرار
            داده و به شرح ذیل از آنها حفاظت به عمل می‌آورد: داده‌هایی که هنگام
            ثبت نام مستقیماً از کاربر مسافر أخذ می‌شود، شامل مشخصات فردی (نام و
            نام خانوادگی)، پست الکترونیک و شماره تلفن همراه، صرفاً در جهت احراز
            هویت کاربر مسافر و امکان برخورداری از خدمات استفاده قرار می‌گیرد.
            شرکت متعهد می‌گردد داده‌های مذکور را صرفا در محدوده ارائه خدمات
            مذکور مورد استفاده قرار دهد. در همین راستا، پس از ارسال درخواست توسط
            کاربر مسافر و قبول درخواست توسط سفیر، داده‌های مزبور در جهت شناسایی
            مسافر و انجام هماهنگی سفیر با وی از قبیل تعیین محل سوار شدن به خودرو
            و زمان آن، با سفیر به اشتراک گزارده می‌شوند. همچنین در شرایطی که
            وسیله یا وسایل متعلق به مسافر در خودرو سفیر جا مانده باشد، استفاده
            از این داده‌ها جهت هماهنگی‌های بعدی صورت می‌پذیرد. تبصره: برابر
            ضوابط مندرج در «شرایط استفاده از خدمات هوشمند جابجایی مسافر برای
            کاربران سفیر» سفیران در راستای حفاظت از داده‌ها و اطلاعات مسافران،
            از ذخیره شماره تماس مسافرانی که از طریق نرم افزار {process.env.REACT_APP_NAME} به آنها
            معرفی شده اند و نیز برقراری ارتباط با ایشان خارج از خدمات {process.env.REACT_APP_NAME}
            منع شده‌اند و در صورت احراز تخلف، شرکت حق تعلیق و خاتمه همکاری با
            سفیر را برای خود محفوظ داشته و مطابق با شرایط و ضوابط صدر‌الذکر با
            متخلف برخورد خواهد کرد. درخصوص داده‌ها و اطلاعاتی که به‌طور
            غیرمستقیم و در نتیجه‌ی استفاده‌ی کاربر مسافر از خدمات {process.env.REACT_APP_NAME} در
            این برنامه ذخیره می‌‌شود، شرکت متعهد می‌‌شود که اطلاعات ذخیره‌شده را
            تنها در جهت بهبود کیفیت خدمات استفاده نماید. در مواردی که سایر
            اشخاص، حسب مورد، بخشی از فرایند ارائه خدمات را تحت نظارت شرکت
            عهده‌دار شوند، شرکت مطابق با اصول، قوانین و مقررات صیانت از حریم
            خصوصی و حفاظت از داده‌ها نسبت به پیشبرد امور اقدام می نماید. شرکت
            متعهد می‌گردد، داده‌ها و اطلاعات کاربران مسافر را به اشخاص ثالث اعم
            از حقیقی و یا حقوقی با مقاصد تجاری و غیرتجاری خارج از حیطه خدمات
            فوق‌الذکر، بدون کسب رضایت صاحبان آن افشا ننماید. تبصره: در صورتی که
            مقامات قضایی و یا اداری به حکم قانون، داده‌ها و یا اطلاعات مربوط به
            کاربر یا کاربران خاصی را از شرکت مطالبه نمایند، شرکت مطابق با قانون
            موظف به افشای آنها به مقامات صالح می‌باشد. ماده ۶- مالکیت حقوق معنوی
            نرم‌افزار {process.env.REACT_APP_NAME} مالکیت مادی و معنوی نرم‌افزار {process.env.REACT_APP_NAME} و تمام
            ملحقات آن (از جمله نام، علامت تجاری و خدمات ارائه‌شده تحت این نام و
            ...) متعلق به شرکت است و در نتیجه: ۶‏-۱- کاربران تنها اجازه‌ی
            استفاده‌ی محدود و غیرانحصاری از خدمات آن را تحت شرایط قرارداد حاضر
            دارند، بدون آن که این استفاده حقی برای آن‌ها نسبت به مالکیت
            نرم‌افزار {process.env.REACT_APP_NAME} یا سایر حقوق معنوی مربوطه ایجاد نماید یا اجازه‌ی
            استفاده از نام، علامت تجاری، لوگو و ... را به آن‌ها اعطا نماید.
            ۶‏-۲- کاربران نمی‌‌توانند نرم‌افزار {process.env.REACT_APP_NAME} را تغییر دهند،
            بازتولید یا بازنویسی کنند یا از آن برای تولید یک برنامه‌ی مشابه
            استفاده نمایند. ۶‏-۳- کاربران مجاز به استفاده از خدمات نرم‌افزار
            {process.env.REACT_APP_NAME} جز در شرایط مقرر در این قرارداد نیستند و حق اجاره، فروش و
            به‌طور کلی انتقال نرم‌افزار {process.env.REACT_APP_NAME} و حقوق ناشی از آن را نخواهد
            داشت. ۶‏-۴- کاربران نمی‌‌توانند به هیچ‌یک از سرویس‌‌ها، برنامه‌ها و
            شبکه‌ی مرتبط با سرورها به‌صورت غیرمجاز دسترسی پیدا کنند یا در این
            راستا تلاشی انجام دهند و نیز نمی‌‌توانند با استفاده از مهندسی معکوس
            یا مترجم وارون به کد سطح بالا یا زبان ماشین دست پیدا کنند. ۶‏-۵-
            کاربران نمی‌‌توانند برنامه را مشابه‌سازی کنند یا بخشی از برنامه را
            درون برنامه‌ی دیگری استفاده نمایند. ماده ۷- تجدیدنظر در شرایط
            استفاده و نحوه ابلاغ آن ۷‏-۱- شرایط حاضر نسبت به کاربران مسافر که
            اپلیکیشن {process.env.REACT_APP_NAME} را نصب کرده و از آن استفاده می‌کنند یا از خدمات
            وب‌اپ و خدمات تلفنی استفاده می‌نماید، اعمال می‌گردد. ۷‏-۲- در صورتی
            که شرایط استفاده تغییر یابد، {process.env.REACT_APP_NAME} مراتب را با یکی از شیوه‌های
            ارسال پیامک، ایمیل، بارگذاری شرایط جدید در وبسایت و اپلیکیشن
            اطلاع‌رسانی می‌نماید. صرف استفاده کاربران از اپلیکیشن پس از تغییر
            شرایط استفاده و اطلاع‌رسانی آن به منزله پذیرش شرایط استفاده جدید
            می‌باشد. ماده ۸- قانون حاکم و شیوه حل اختلاف شرایط استفاده حاضر از
            هر نظر تابع قوانین جمهوری اسلامی ایران خواهد بود و در صورت بروز
            اختلاف، طرفین تلاش خواهند کرد تا اختلاف خود را به‌صورت مسالمت‌آمیز و
            از راه گفت‌وگو حل‌وفصل نمایند. در صورت عدم موفقیت، اختلاف از طریق
            مراجعه به مراجع قضایی تهران حل‌وفصل خواهد شد. ماده ۹- توافقات نهائی
            ۹‏-۱- کاربران مسافر تصدیق می‌نمایند که «شرایط استفاده از خدمات
            هوشمند جابجایی مسافر {process.env.REACT_APP_NAME} برای کاربران مسافر» را به‌طور کامل
            مطالعه نموده، از مفاد و شرایط آن آگاهی کامل داشته و نسبت به اعمال
            تمامی این شرایط رضایت دارند و نسبت به مفاد آن ملتزم می‌باشند. ۹‏-۲-
            در مواردی که متن حاضر، صراحتاً یا ضمناً حاوی حکمی نباشد، مراتب تابع
            عرف رایج در این صنعت می‌باشد.
          </span> */}
        </div>
        </>
        <button
          className="btn btn-outline-primary m-2 block"
          onClick={props.onChange}
        >
          متوجه شدم
        </button>
      </Modal>
    )
 
}


